import {
    Component,
    computed,
    input,
    OnInit,
    QueryList, signal, untracked,
    ViewChildren
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import {
    RadioBoxButtonComponent,
    RadioBoxButtonComponentInterface,
    wrapBelow
} from '@shared/interactions/radio-box-button/radio-box-button.component';

@Component({
    selector: 'radio-box-group',
    templateUrl: './radio-box-group.component.html',
    styleUrl: './radio-box-group.component.scss',
    standalone: false
})
export class RadioBoxGroupComponent implements ControlValueAccessor, OnInit {
    protected control: FormControl = new FormControl();

    public items = input.required<RadioBoxButtonComponentInterface[]>();

    @ViewChildren(RadioBoxButtonComponent)
    protected radioButtonElements!: QueryList<RadioBoxButtonComponent>;

    protected itemsComputed = computed(() => {
        const isInputFocused = untracked(
            this.radioButtonElements
                ?.find(item => item.type() === 'custom')
                ?.isFocused || signal(false)
        );

        if (isInputFocused || this.items().some(item => item.value === this.control.value)) {
            return this.items();
        }

        return this.items().map(item => item.type === 'custom'
            ? { ...item, value: this.control.value }
            : item
        );
    });

    public wrapBelow = input<wrapBelow>('md');

    // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
    private onChange = (url: string): void => { };

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private onTouched = (): void => { };

    constructor(
        private controlDirective: NgControl
    ) {
        this.controlDirective.valueAccessor = this;
    }

    public ngOnInit(): void {
        this.control = this.controlDirective.control as FormControl;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(val: string): void {
        if (!this.control.value) {
            this.control.setValue(val);
        }
    }
}
